<template>
<div class="breadcrumb-container">
  <el-breadcrumb ref="breadcrumb" style="margin:10px;" separator-class="el-icon-arrow-right">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="item in this.curRouterArr" :key="item.ID">
        <i :class="item.Icon"></i>
        {{item.Name}}
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
  </div>
</template>

<script>
export default {
  data() {
    return {
      curRouterArr: []
    };
  },
  watch: {
    // $route: function(newRoute, oldRoute) {
    //   this.setBreadcrumb(decodeURIComponent(this.$route.fullPath));
    // }
  },
  created() {
    // window.sessionStorage.setItem("curMenu", this.$route.fullPath);
    let curMenu=this.$$store.getters.getCurMenu;
    this.setBreadcrumb(curMenu);
  },
  mounted() {
    this.$nextTick(() => {
      let breadcrumb = JSON.parse(window.sessionStorage.getItem("menuArr"));
      if (breadcrumb) {
        this.curRouterArr = breadcrumb;
      }
    });
  },
  methods: {
    //根据路由设置面包屑
    setBreadcrumb(url) {
      this.curRouterArr = [];
      let curRouter = this.$store.state.menuData.find(item => {
        return item.Url === url;
      });
      if (curRouter) {
        this.curRouterArr.unshift(curRouter);
        this.setCurRouterArr(curRouter.ParentID);
        //将面包屑数据保存到会话，若页面刷新将从会话中获取面包屑数据
        window.sessionStorage.setItem(
          "menuArr",
          JSON.stringify(this.curRouterArr)
        );
      }
    },
    //向CurRouterArr添加路由信息
    setCurRouterArr(pid) {
      var findVal = this.$store.state.menuData.find(item => {
        return item.ID === pid;
      });
      if (findVal) {
        //找到了匹配的添加到curRouterArr中的第一位,并递归查询
        this.curRouterArr.unshift(findVal);
        this.setCurRouterArr(findVal.ParentID);
      } else {
        return;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.breadcrumb-container {
  background: #fff;
  display: flex;
  align-items: center;
  height: 30px;
}
</style>
